import { ReconciliationState } from "@/vuex/modules/inventory/reconciliation/reconciliation.types";

export const state = (): ReconciliationState => ({
  headerData: { data: [], total: 0, reconcilable: 0, synchronized: 0 },
  reconciliations: [],
  loading: false,
  pagination: null
});
